(() => {
  const page = document.querySelector('[data-general-contact-page]');

  if (!page || page.dataset.jiscGeneralContactEnhanced === 'true') {
    return;
  }

  page.dataset.jiscGeneralContactEnhanced = 'true';

  const form = page.querySelector('#ContactForm');

  if (!form) {
    return;
  }

  const successMessage = form.querySelector('[data-contact-form-success]');
  const topicInputs = Array.from(form.querySelectorAll('[data-contact-topic]'));
  const conditionalRegion = form.querySelector('[data-contact-conditional-region]');
  const conditionalPanels = Array.from(form.querySelectorAll('[data-contact-topic-panel]'));
  const scannerHandoff = page.querySelector('[data-scanner-handoff]');
  const scannerHandoffProduct = page.querySelector('[data-scanner-handoff-product]');
  const scannerHandoffLink = page.querySelector('[data-scanner-handoff-link]');
  const quoteBanner = page.querySelector('[data-contact-quote-banner]');

  const removeContactSuccessMarker = () => {
    const successUrl = new URL(window.location.href);

    if (!successUrl.searchParams.has('contact_posted')) {
      return;
    }

    successUrl.searchParams.delete('contact_posted');
    window.history.replaceState(window.history.state, '', successUrl.toString());
  };

  const scheduleContactSuccessMarkerCleanup = () => {
    const scheduleCleanup = () => {
      window.setTimeout(removeContactSuccessMarker, 5000);
    };

    if (document.readyState === 'complete') {
      scheduleCleanup();
      return;
    }

    window.addEventListener('load', scheduleCleanup, { once: true });
  };

  const publishContactSuccess = () => {
    if (
      !successMessage ||
      successMessage.dataset.contactEventFired === 'true' ||
      !window.Shopify ||
      !window.Shopify.analytics ||
      typeof window.Shopify.analytics.publish !== 'function'
    ) {
      return false;
    }

    successMessage.dataset.contactEventFired = 'true';

    try {
      window.Shopify.analytics.publish('jisc_scanners:contact_form_submitted', {
        form_type: 'general_contact',
      });
      return true;
    } catch {
      delete successMessage.dataset.contactEventFired;
      return false;
    }
  };

  if (successMessage) {
    scheduleContactSuccessMarkerCleanup();

    if (!publishContactSuccess()) {
      window.addEventListener('load', publishContactSuccess, { once: true });
    }
  }

  const updateConditionalFields = () => {
    const selectedTopic = topicInputs.find((input) => input.checked)?.dataset.contactTopic || '';
    let visiblePanelCount = 0;

    conditionalPanels.forEach((panel) => {
      const supportedTopics = (panel.dataset.contactTopicPanel || '').split(/\s+/).filter(Boolean);
      const isVisible = selectedTopic !== '' && supportedTopics.includes(selectedTopic);

      panel.hidden = !isVisible;

      panel.querySelectorAll('input, select, textarea').forEach((control) => {
        const isRequiredWhenVisible = control.hasAttribute('data-contact-required');
        control.disabled = !isVisible;
        control.required = isVisible && isRequiredWhenVisible;

        if (isRequiredWhenVisible) {
          control.setAttribute('aria-required', isVisible ? 'true' : 'false');
        }
      });

      if (isVisible) {
        visiblePanelCount += 1;
      }
    });

    if (conditionalRegion) {
      conditionalRegion.hidden = visiblePanelCount === 0;
    }
  };

  topicInputs.forEach((input) => {
    input.addEventListener('change', updateConditionalFields);
  });

  const showScannerHandoff = () => {
    if (!scannerHandoff || !scannerHandoffProduct || !scannerHandoffLink) {
      return;
    }

    const scanner = new URL(window.location.href).searchParams.get('scanner');
    const normalizedScanner = scanner ? scanner.trim().slice(0, 120) : '';

    if (normalizedScanner === '') {
      return;
    }

    const quoteUrl = new URL(page.dataset.quoteUrl || '/pages/contact?view=contact-quote', window.location.origin);
    quoteUrl.searchParams.set('scanner', normalizedScanner);
    quoteUrl.hash = 'QuoteForm';

    scannerHandoffProduct.textContent = normalizedScanner;
    scannerHandoffLink.href = `${quoteUrl.pathname}${quoteUrl.search}${quoteUrl.hash}`;
    scannerHandoff.hidden = false;

    if (quoteBanner) {
      quoteBanner.hidden = true;
    }
  };

  updateConditionalFields();
  showScannerHandoff();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateConditionalFields, { once: true });
  }

  window.addEventListener('pageshow', updateConditionalFields);
})();
